import { useState } from "react"
import { useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"

import { logMessage } from "src/logging"
import ModalService from "src/modals"
import { forgotPassword } from "src/store/user"

import Modal from "src/components/modals/Modal"
import { apiErrorLines } from "src/utils/apiErrors"

const ForgotPasswordModal = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [errors, setErrors] = useState([])
  const [formData, setFormData] = useState({
    email: "",
  })
  const handleSubmit = (e) => {
    e.preventDefault()

    dispatch(forgotPassword(formData.email))
      .unwrap()
      .catch(() => null)
      .finally(() => {
        ModalService.hideAll()
        logMessage({ type: "success", text: t("auth.recoveryEmailSent") })
      })
  }
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
    setErrors([])
  }

  return (
    <Modal>
      <h1>{t("auth.forgotPasswordTitle")}</h1>
      {apiErrorLines(errors).map(({ key, text }) => (
        <p key={key} className="errored-text">
          <br />
          {text}
        </p>
      ))}
      <br />
      <br />

      <form onSubmit={handleSubmit}>
        <label htmlFor="email">{t("auth.emailLabel")}</label>
        <input
          type="text"
          id="email"
          name="email"
          className="form-input"
          placeholder={t("auth.emailPlaceholder")}
          value={formData.email}
          onChange={handleInputChange}
          required
        />

        <br />
        <br />

        <div style={{ display: "flex", justifyContent: "center", gap: "3%" }}>
          <button type="submit">{t("auth.sendEmail")}</button>
        </div>
      </form>
    </Modal>
  )
}

export default ForgotPasswordModal
